export enum ShiftRequirementType {
  TwelveHour = '12_hour_shift',
  Weekends = 'weekends',
  PublicHolidays = 'public_holidays',
  TwoAtLeast = 'atleast_two_shifts_of_three',
  ThreeShifts = 'three_shifts',
}

export const EMPLOYER_SHIFT_REQUIREMENTS = [
  ShiftRequirementType.PublicHolidays,
  ShiftRequirementType.ThreeShifts,
  ShiftRequirementType.TwelveHour,
  ShiftRequirementType.TwoAtLeast,
  ShiftRequirementType.Weekends,
];

export const SHIFT_REQUIREMENT_TYPE_TRANSLATIONS = {
  [ShiftRequirementType.TwelveHour]: '12h-Schichten',
  [ShiftRequirementType.Weekends]: 'Wochenende',
  [ShiftRequirementType.PublicHolidays]: 'Feiertage',
  [ShiftRequirementType.TwoAtLeast]: 'Mindestens 2 Schichten',
  [ShiftRequirementType.ThreeShifts]: '3-Schichtsystem',
};
